import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellRing, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { pushSupported, getPushState, enablePush } from "../lib/push";

export const EnableNotifications = () => {
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => { getPushState().then(setState); }, []);

  if (state === "loading" || state === "unsupported" || state === "on") return null;

  const turnOn = async () => {
    setBusy(true);
    try {
      await enablePush();
      setState("on");
      toast.success("Alerts on — we'll notify you here when a new enquiry lands");
    } catch (e) {
      if (e.message === "denied") toast.error("Notifications are blocked. Enable them in your browser/site settings, then try again.");
      else toast.error("Couldn't turn on alerts. On iPhone, add TradieDesk to your Home Screen first, then try again.");
      setState(await getPushState());
    } finally { setBusy(false); }
  };

  return (
    <Button data-testid="enable-notifications-btn" onClick={turnOn} disabled={busy} size="sm" variant="outline"
      className="rounded-sm border-primary/40 text-primary hover:bg-primary/10 gap-1.5 h-9">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />}
      <span className="hidden sm:inline">Turn on alerts</span>
    </Button>
  );
};
